<template>
<div>

  <nav class="navbar is-active" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      
      <a class="navbar-item" href="">
        <b>APPKA</b>
        <!--        <img src="https://bulma.io/images/bulma-logo.png" width="112" height="28">-->
      </a>


      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu">
<!--      <div class="navbar-start">-->
<!--        <a class="navbar-item">-->
<!--          <router-link to="/">Home</router-link>-->
<!--        </a>-->


<!--        <a class="navbar-item">-->
<!--          Documentation-->
<!--        </a>-->

<!--        <div class="navbar-item has-dropdown is-hoverable">-->
<!--          <a class="navbar-link">-->
<!--            More-->
<!--          </a>-->

<!--          <div class="navbar-dropdown">-->
<!--            <a class="navbar-item">-->
<!--              About-->
<!--            </a>-->
<!--            <a class="navbar-item">-->
<!--              Jobs-->
<!--            </a>-->
<!--            <a class="navbar-item">-->
<!--              Contact-->
<!--            </a>-->
<!--            <hr class="navbar-divider">-->
<!--            <a class="navbar-item">-->
<!--              Report an issue-->
<!--            </a>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <!-- == SEARCH == -->
      <!-- <div class="navbar-item">
        <p class="control has-icons-left">
          <input class="input is-small" type="text" placeholder="search">
          <span class="icon is-small is-left">
          <i class="fas fa-search" aria-hidden="true"></i>
        </span>
        </p>
      </div> -->

      <div class="navbar-item">
        <p v-if="getProfile">xxx {{getProfile.name}}</p>
      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <!--
            <a class="button is-primary">
              <strong>Sign up</strong>
            </a>
            -->
            <a class="button is-light"  @click="logout">
              Logout
            </a>
          </div>
        </div>
      </div>

    </div>
  </nav>

</div>
</template>

<script>
    import { AUTH_REQUEST, AUTH_LOGOUT} from '../../store/actions/auth'
    import { mapState } from 'vuex'

    export default {
      name: 'NavBar',
      methods: {
        login: function () {
          const { username, password } = this;
          this.$store.dispatch(AUTH_REQUEST, { username, password }).then(() => {
            this.$router.push('/user/xxx/dashboard')
          })
        },
        logout: function () {
          this.$store.dispatch(AUTH_LOGOUT).then(() => {
            this.$router.push('/')
          })
        }
      },
      computed: mapState(['getProfile']),
      watch: {
        getProfile(newValue, oldValue) {
          console.log(`Updating from ${oldValue} to ${newValue}`);
        }
      }
    }
</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  /*background: #118575;*/
  background: #0E6A5D;
}
  .navbar-item {
    color: white;
  }
</style>
